import { render, staticRenderFns } from "./urunsatinal.vue?vue&type=template&id=595efea8&"
import script from "./urunsatinal.vue?vue&type=script&lang=js&"
export * from "./urunsatinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports